@if (!readonly()) {
  <div [class]="fieldClasses()">
    @if (labelText) {
      <label
        [class]="labelClasses()"
        [attr.for]="inputId() || null"
      >
        @if (resolvedLabelIcon) {
          <ng-icon
            [name]="resolvedLabelIcon"
            class="icon-size-4 text-current"
          ></ng-icon>
        }
        <span>{{ labelText }}</span>
      </label>
    }

    <div class="relative">
      @if (resolvedPrefixIcon) {
        <ng-icon
          [name]="resolvedPrefixIcon"
          class="pointer-events-none absolute left-3 top-1/2 z-10 -translate-y-1/2 icon-size-4 text-secondary"
        ></ng-icon>
      }

      <z-select
        [class]="selectClasses()"
        [zMaxHeight]="240"
        [zSize]="effectiveSize()"
        [attr.id]="inputId() || null"
        [zDisabled]="disabled() || (loading() && !externalSearch())"
        [zPlaceholder]="placeholder() || ''"
        [zLabel]="selectedOption?.text || ''"
        [zValue]="selectedOptionKey"
        zAppearance="ds"
        (zSelectionChange)="onZardSelectionChange($event)"
        (zOpenChange)="!$event && closeOptions()"
      >
        @if (showSearchInput && !(selectedOption && hideOptionsWhenSelected())) {
          <div class="sticky top-0 z-[1] border-b border-[#f0f2f5] bg-popover pb-1">
            <label [class]="searchBoxClasses">
              <ng-icon
                name="svcSearch"
                class="icon-size-4 shrink-0 text-[#757575]"
                aria-hidden="true"
              ></ng-icon>
              <input
                type="text"
                [value]="searchText"
                [placeholder]="(externalSearch() ? 'Pesquisar remotamente' : 'Pesquisar') | transloco"
                [attr.aria-label]="(externalSearch() ? 'Pesquisar remotamente' : 'Pesquisar') | transloco"
                (input)="onSearchInput($event)"
                class="w-full flex-1 border-0 bg-transparent text-sm leading-5 text-[#0d122f] outline-none placeholder:text-[#757575]"
              />
            </label>
          </div>
        }

        @if (selectedOption && hideOptionsWhenSelected()) {
          <div class="px-3 py-2 text-sm text-secondary">
            {{ 'Você pode selecionar apenas 1 item.' | transloco }}
          </div>
        } @else if (externalSearch() && searchText.length < minCharactersExternalSearchLength()) {
          <div class="px-3 py-2 text-sm text-secondary">
            {{ 'Digite mais {{count}} caractere(s).' | transloco: { count: minCharactersExternalSearchLength() - searchText.length } }}
          </div>
        } @else if (loading() && externalSearch()) {
          <div class="px-3 py-2 text-sm font-medium text-default">
            {{ 'Pesquisando...' | transloco }}
          </div>
        } @else if (!hasLocalResults && !loading()) {
          <div class="px-3 py-2 text-sm text-muted-foreground">
            {{ 'Nenhum resultado encontrado.' | transloco }}
          </div>
        } @else {
          @for (group of groupedOptions; track group.trackKey) {
            @if (group.groupLabel) {
              <button
                type="button"
                [class]="groupHeaderClasses"
                [attr.aria-expanded]="!isGroupCollapsed(group.groupKey)"
                (click)="toggleGroup(group.groupKey, $event)"
              >
                <ng-icon
                  name="svcChevDown"
                  class="icon-size-3 shrink-0 transition-transform duration-150"
                  [class.-rotate-90]="isGroupCollapsed(group.groupKey)"
                  aria-hidden="true"
                ></ng-icon>
                <span class="truncate">{{ group.groupLabel }}</span>
              </button>
            }

            @if (!isGroupCollapsed(group.groupKey)) {
              @for (option of group.options; track option.key) {
                <z-select-item
                  [zValue]="option.key"
                  [zDisabled]="option.disabled"
                  zMarker="circle-check"
                  zAppearance="ds"
                  [class]="optionRowClasses"
                >
                  @if (!templateRef()) {
                    {{ renderOptionText(option) }}
                  } @else {
                    <ng-container
                      [ngTemplateOutlet]="templateRef()"
                      [ngTemplateOutletContext]="{ option: option, rederingInList: true }"
                    ></ng-container>
                  }
                </z-select-item>
              }
            }
          }
        }
      </z-select>
    </div>

    <svz-validation-message [control]="control"></svz-validation-message>
  </div>
} @else {
  <div class="flex w-full flex-col gap-1">
    @if (labelText) {
      <div class="inline-flex items-center gap-1 text-sm font-medium text-default">
        @if (resolvedPrefixIcon) {
          <ng-icon
            [name]="resolvedPrefixIcon"
            class="icon-size-4 text-current"
          ></ng-icon>
        }
        <span>{{ labelText }}</span>
      </div>
    }

    @if ((readonlyStyle() === 'chip' || readonlyStyle() === 'transparent-chip') && selectedOption) {
      <div
        class="inline-flex w-fit max-w-full items-center rounded-full px-2 py-1 text-sm"
        [class.bg-hover]="readonlyStyle() === 'chip'"
        [class.bg-transparent]="readonlyStyle() === 'transparent-chip'"
      >
        @if (!templateRef()) {
          <span [class.truncate]="truncateTextValue()">{{ selectedOption.text }}</span>
        } @else {
          <ng-container
            [ngTemplateOutlet]="templateRef()"
            [ngTemplateOutletContext]="{ option: selectedOption, rederingInList: false }"
          ></ng-container>
        }
      </div>
    } @else {
      <span
        class="text-base font-medium text-default"
        [class.truncate]="truncateTextValue()"
      >
        {{ selectedOption?.text || fallbackTextValue() || '' }}
      </span>
    }
  </div>
}
